
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { BookingItemProps } from ".";
import { loading, update } from "store/booking";

interface ApiBookingUpdateInputProps extends BookingItemProps {
}

type ApiBookingUpdateOutputProps = OutputBaseProps<{ item: BookingItemProps; }, ApiBookingUpdateInputProps>

export const apiBookingUpdate = async (data: ApiBookingUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiBookingUpdateOutputProps>("/api/booking/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
    }
    return res;
};